import { format, parse } from "date-fns";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FormControl, FormHelperText } from "@mui/material";

export const CustomTimePicker = ({
  label = "",
  size = "small",
  name = "",
  value = "",
  onChange,
  error = "",
  helperText = "",
  formatString = "HH:mm",
  disabled = false,
  is24HourFormat = true,
}) => {
  const formatTimeString = (timeString) => {
    const formated = !!timeString
      ? parse(timeString, "HH:mm", new Date())
      : null;
    return formated;
  };

  const handleChange = (value) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: value ? format(value, formatString) : "",
        },
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl
        fullWidth
        size={size}
        error={!!error}
        disabled={disabled}
        sx={{ mt: 2 }}
      >
        <TimePicker
          name={name}
          label={label}
          value={formatTimeString(value)}
          onChange={handleChange}
          ampm={!is24HourFormat}
          disabled={disabled}
          slotProps={{
            textField: {
              size,
              fullWidth: true,
              error: !!error,
            },
          }}
        />
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
        {!!error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  );
};
